import { ISiteSettings } from '@/interfaces/powerMarkets/settings/ISiteSettings.ts';

export interface IPlantGroupColourSettings {
    override: boolean;
    colour: string;
}

export function getSelectedPlantIds (siteSettings: ISiteSettings): Array<string> {
    if (!siteSettings.chosenPlantGroupName) return [];
    return siteSettings.chosenPlantsByGroup[siteSettings.chosenPlantGroupName] ?? [];
}

export function getPlantGroupColourSettings (siteSettings: ISiteSettings, groupName: string): IPlantGroupColourSettings {
    return siteSettings.plantGroupColourOverrideByGroup[groupName] ?? {
        override: false,
        colour: siteSettings.defaultPlantGroupColour,
    };
}

export function getSelectedPlantGroupColourSettings (siteSettings: ISiteSettings): IPlantGroupColourSettings {
    if (!siteSettings.chosenPlantGroupName) {
        return {
            override: false,
            colour: siteSettings.defaultPlantGroupColour,
        };
    }

    return getPlantGroupColourSettings(siteSettings, siteSettings.chosenPlantGroupName);
}
